import { SuperBit_swaggerClient, FilterDataModel, UsersModel as UsersDataModel, RoleModel, SortModel, UserCreateModel } from './superbit-api-models';
import generalSettings from '../json/general-settings.json';

// Service wrapper for the System Management "Users" tab.
// Mirrors the data the old MVC _Users.cshtml view rendered (account/userSort)
// and the role list it used for filtering (maintenance/groupSort).
export class UsersModel {
    client: any;

    constructor() {
        const apiUrl = localStorage.getItem('apiUrl');
        const url = apiUrl ? apiUrl : generalSettings.apiUrl;

        // Some generated client methods omit the Authorization header; inject it
        // here (only when absent) so every call through this client is authenticated.
        const authHttp = {
            fetch(input: RequestInfo, init?: RequestInit) {
                const token = localStorage.getItem('AuthToken');
                const headers: any = { ...(init && init.headers ? init.headers : {}) };
                if (token && !headers['Authorization']) {
                    headers['Authorization'] = `Bearer ${token}`;
                }
                return window.fetch(input, { ...(init || {}), headers });
            },
        };

        this.client = new SuperBit_swaggerClient(url, authHttp);
    }

    // Sorted/filtered/paged users list (replaces _UserItems.cshtml + _Paging.cshtml).
    async userSort(filter: FilterDataModel): Promise<UsersDataModel> {
        return await this.client.userSort(filter);
    }

    async userDelete(id: string): Promise<void> {
        return await this.client.userDelete(id);
    }

    // Loads the create/edit form model. Passing no id (add mode) returns a fresh
    // model already populated with the Roles/SalesPeople/Branches/OfficeDepartments
    // dropdown lists; passing an id (edit mode) also fills the user's current values.
    async userGet(id?: string): Promise<UserCreateModel> {
        return await this.client.userGet(id);
    }

    // Create AND edit both post through userCreate (the server upserts by Id),
    // mirroring the old MVC _NewUser form which always posted to User/Create.
    async userCreate(model: UserCreateModel): Promise<void> {
        return await this.client.userCreate(model);
    }

    // Async uniqueness check used before submit (Id excludes the current user on edit).
    async userCheckEmailExists(email: string, id?: string): Promise<boolean> {
        return await this.client.userCheckEmailExists(email, id);
    }

    // Roles/groups used to populate the "קבוצה" filter dropdown.
    async getRoles(): Promise<RoleModel[]> {
        return await this.client.groupSort([] as SortModel[]);
    }

    // The dropdown/tree lists used by the table filters and the "איש מכירות"
    // column: sales people (value = id, text = name), branches and office
    // departments. These come from the same add-mode form model the add/edit
    // dialog uses (the userSort list only returns ids, not names/trees).
    async getFormLists(): Promise<UserCreateModel> {
        return await this.client.userGet(undefined);
    }
}
